export const emptyFilter = {};